import {needAuth} from "../instance/Instance";
import {commonChangeResponseMessage, commonResponseMessage, getPages} from "../../components/commonmethod/CommonMethod";
import {handleActiveError, handleActiveToast} from "../../components/sonner/ToastBasic";

async function getLicense(id) {
    console.log(">>> api : 라이선스 단건 조회")
    return  await needAuth.get('/license/'+ id);
}

async function getLicenseList(search, pageable) {
    const start = performance.now();
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;
    try{
        return  await needAuth.post('/license?'+pageStr,search);
    }catch (error){
        return error;
    }finally {
        const end = performance.now(); // 함수 호출 후 현재 시간 측정
        const executionTime = ((end - start)/1000).toFixed(2); // 함수 실행에 걸린 시간 계산
        console.log(`>>> api : 라이선스 리스트 조회 완료시간 : ${executionTime} 초`);
    }
}


async function createLicense(license, files, assets, licenseKeys) {
    console.log(">>> api : 라이선스 등록")
    const formData = new FormData();
    files.forEach((file, index) => {
        formData.append(`files`, file);
    });

    
    const licenseAsset =new Array();
    //라이선스 키 자산 등록
    licenseKeys?.forEach(asset => {
        if (Object.entries(asset.asset).length > 0 && asset.key.length > 0) {
            //라이선스 키 자산 등록시 자산이 있고 키가 있을때
            const newKeyAsset = {
                asset: { id: asset.asset.id },
                licenseKey: asset.key
            };
            licenseAsset.push(newKeyAsset);
        }else if (Object.entries(asset.asset).length === 0 && asset.key.length > 0){
            //라이선스 키 자산 등록시 자산이 없고 키가 있을때
            const newKeyAsset = {
                asset: { id: null},
                licenseKey: asset.key
            };
            licenseAsset.push(newKeyAsset);
        }else if (asset.key.length === 0 && Object.entries(asset.asset).length > 0){
            //라이선스 키 자산 등록시 자산이 있고 키가 없을때
            const newKeyAsset = {
                asset: { id: asset.asset.id },
                licenseKey: ""
            };
            licenseAsset.push(newKeyAsset);
        }
    });

    if (licenseAsset.length > 0) {
        license.assets = licenseAsset;
    }
    else if (licenseAsset.length == 0) {
        license.assets = [];
    }


    formData.append(
        "licenseRequestDto",
        new Blob([JSON.stringify(license)], { type: "application/json" })
    );
    return await needAuth.post(
        '/license/create',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }
    );

}
async function updateLicense(data) {
    return await needAuth.put(`/license`, data);

}


async function addLicenseKeyById(id) {



    let response = await needAuth.put(`/license/licenseKey`, { id: id});

    if (response.status === 200) {
        commonResponseMessage(response, true, "라이선스 키");
        return true;
    } else if (response.status === 201 || (response.status === 202)) {
        handleActiveError({message: response.data.title, description: response.data.reason});
        return false;
    } else {
        handleActiveError({message: '처리실패', description: '알수 없는 원인'})
        ;return false;
    }


}


async function deleteLicenseKeyById(id,LicenseKeyId) {


        let response = await needAuth.delete(`/license/licenseKey`,{  params: { id: id, LicenseKeyId : LicenseKeyId }});
        if (response.status === 200) {
            commonResponseMessage(response, false, "라이선스 키");
            return true;
        } else if (response.status === 201 || (response.status === 202)) {
            handleActiveError({message: response.data.title, description: response.data.reason});
            return false;
        } else {
            handleActiveError({message: '처리실패', description: '알수 없는 원인'})
            ;return false;
        }
        // return commonResponseMessage(response, false, "라이선스 키");

}



async function updateLicenseHandler(id, handlerId, add) {
    if(add) {
        let response =  await needAuth.put(`/license/${id}/add-handler/${handlerId}`);

        if (response.status === 200) {
            commonResponseMessage(response, add, "담당자");
            return true;
        } else if (response.status === 201 || (response.status === 202)) {
            handleActiveError({message: response.data.title, description: response.data.reason});
            return false;
        } else {
            handleActiveError({message: '처리실패', description: '알수 없는 원인'})
            ;return false;
        }
        // return commonResponseMessage(response, add, "담당자");
    }
    else {
        let response =  await needAuth.delete(`/license/${id}/remove-handler/${handlerId}`);
        if (response.status === 200) {
            commonResponseMessage(response, add, "담당자");
            return true;
        } else if (response.status === 201 || (response.status === 202)) {
            handleActiveError({message: response.data.title, description: response.data.reason});
        } else {
            handleActiveError({message: '처리실패', description: '알수 없는 원인'});
        }
        // return commonResponseMessage(response, add,"담당자");
    }
}


async function updateLicenseKeyAsset(id, assetId, add, existingAssetId) {

    console.log(">>> api : 라이선스 키 자산 등록")

    if(!add){

        let response =  await needAuth.delete(`/license/${id}/add-asset-key/${assetId}`,{  params: { existingAssetId }});
        if (response.status === 200) {
            commonResponseMessage(response, add, "자산");
            return true;
        } else if (response.status === 201 || (response.status === 202)) {
            handleActiveError({message: response.data.title, description: response.data.reason});
            return false;
        } else {
            handleActiveError({message: '처리실패', description: '알수 없는 원인'})
            ;return false;
        }
    }else {

        let response = await needAuth.put(`/license/${id}/add-asset-key/${assetId}`, {  existingAssetId });
        if (response.status === 200) {
            commonChangeResponseMessage(response, "자산");
            return true;
        } else if (response.status === 201 || (response.status === 202)) {
            handleActiveError({message: response.data.title, description: response.data.reason});
            return false;
        } else {
            handleActiveError({message: '처리실패', description: '알수 없는 원인'})
            ;return false;
        }
    }

}

async function updateLicenseKey(data,id) {

    let response = await needAuth.put(`/license/${id}/add-key`, data);
    if (response.status === 200) {
        commonChangeResponseMessage(response, "라이선스 키");
        return true;
    } else if (response.status === 201 || (response.status === 202)) {
        handleActiveError({message: response.data.title, description: response.data.reason});
        return false;
    } else {
        handleActiveError({message: '처리실패', description: '알수 없는 원인'});
        return false;
    }



}

async function removeLicenses(ids) {

        let response = await needAuth.put('/license/delete', ids);
        return response;

}

async function getLicenseListByAsset(assetId, pageable) {
    try{
        return  await needAuth.get(`/license/asset/${assetId}?`+getPages(pageable));
    }catch (error){
        return error;
    }
}





export {getLicenseListByAsset, getLicense, getLicenseList, createLicense, updateLicense, updateLicenseHandler, updateLicenseKeyAsset,updateLicenseKey, removeLicenses, deleteLicenseKeyById, addLicenseKeyById};